import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteOfferRegionFilterExclusion } from '~/services/PromoService';

import { offerRegionFilterExclusionQueryKeys } from './offerRegionFilterExclusionQueryKeys';

export function useDeleteOfferRegionFilterExclusion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteOfferRegionFilterExclusion(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: offerRegionFilterExclusionQueryKeys.lists() });
    },
  });
}
